import { Component, Input } from '@angular/core';

import { WpViewPercentageData } from '../../../core';

import { TranslationKeyMap } from './percentage.component.i18n';

@Component({
    selector: 'cmps-wp-percentage',
    templateUrl: './percentage.component.html',
})
export class PercentageComponent {
    @Input() data: WpViewPercentageData;

    /** @private */ _i18n = TranslationKeyMap;
}
